import { HandledError } from "./errors"
import { alertDisplay } from "./errors/text"

export function isHandledError(e: unknown): e is HandledError {
  return e instanceof HandledError
}

export function getGenericAlert() {
  return alertDisplay.generic
}
